import {
  LEGALFRACTION_LOADING,
  GET_LEGALFRACTION,
  GET_LEGALFRACTION_SUCCESS,
  GET_LEGALFRACTION_FAIL,
  ADD_LEGALFRACTION_SUCCESS,
  ADD_LEGALFRACTION_FAIL,
  DELETE_LEGALFRACTION_SUCCESS,
  DELETE_LEGALFRACTION_FAIL,
  UPDATE_LEGALFRACTION_SUCCESS,
  UPDATE_LEGALFRACTION_FAIL,
  LEGALFRACTION_RESET
} from "./actionType";

const INIT_STATE = {
  legalFractions: [],
  error: {},
};

const LegalFraction = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_LEGALFRACTION_SUCCESS:
      switch (action.payload.actionType) {
        case GET_LEGALFRACTION:
          return {
            ...state,
            legalFractions: action.payload.data,
            isLegalFractionCreated: false,
            isLegalFractionSuccess: true,
            loading: false,
          };

        default:
          return { ...state };
      }
    case GET_LEGALFRACTION_FAIL:
      switch (action.payload.actionType) {
        case GET_LEGALFRACTION_FAIL:
          return {
            ...state,
            error: action.payload.error,
            isLegalFractionCreated: false,
            isLegalFractionSuccess: false,
            loading: false,
          };
        default:
          return { ...state };
      }

    case GET_LEGALFRACTION: {
      return {
        ...state,
        isLegalFractionCreated: false,
        loading: true,
      };
    }

    case LEGALFRACTION_LOADING: {
      return {
        ...state,
        isLegalFractionCreated: false,
        loading: true,
      };
    }

    case ADD_LEGALFRACTION_SUCCESS:
      return {
        ...state,
        isLegalFractionCreated: true,
        loading: false,
        legalFractions: [action.payload.data, ...state.legalFractions],
      };

    case ADD_LEGALFRACTION_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case DELETE_LEGALFRACTION_SUCCESS:
      return {
        ...state,
        loading: false,
        legalFractions: state.legalFractions.filter(
          legalFraction => legalFraction.id.toString() !== action.payload.id.toString()
        ),
      };

    case DELETE_LEGALFRACTION_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case UPDATE_LEGALFRACTION_SUCCESS:
      return {
        ...state,
        loading: false,
        legalFractions: state.legalFractions.map(legalFraction =>
          legalFraction.id.toString() === action.payload.data.id.toString() ? { ...legalFraction, ...action.payload.data } : legalFraction
        ),
      };

    case UPDATE_LEGALFRACTION_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case LEGALFRACTION_RESET:
      return INIT_STATE;

    default:
      return { ...state };
  }
};

export default LegalFraction;